import { toast } from "react-toastify";
import axiosInstance from "./axios.instance";
class LoanApplicationService {

  async submitLoanApplication(formData) {
    try {
      const response = await axiosInstance.post(
        "/loan-applications",
        formData,
        {
          headers: {
        "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      let errorMessage = "Failed to submit loan application"; // Default fallback

      if (error.response?.data) {
        const { message, data } = error.response.data;

        if (data?.error) {
          // Prioritize the `data.error` message
          errorMessage = data.error;
        } else if (Array.isArray(message) && message.length > 0) {
          // Case: message is an array (e.g., ["email must be an email"])
          errorMessage = message[0];
        } else if (
          typeof message === "string" &&
          message !== "error.updating_customer"
        ) {
          // Case: message is a single string (but not "error.updating_customer")
          errorMessage = message;
        }
      }

      toast.error(errorMessage);
      throw error;
    }
  }


  async fetchDocuments(customerId) {
    try {
      const response = await axiosInstance.get(
        `/loan-applications/customer/${customerId}`
      );
      return response.data?.data?.data;
    } catch (error) {
      console.error("Error fetching documents:", error);
      throw error;
    }
  }

  async deleteDocument(id, filename) {
    try {
      const response = await axiosInstance.delete(
        `/customers/document`,
        {
          params: {
            loan_application_id: id,
            original_name: filename,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new LoanApplicationService();
